/**
 *
 * @param val 待判断是否为有效数字的任意变量
 * @returns 是否为有效值
 * @description 有效值的定义：
 * - 对于普通类型：类型为‘number’ 且 非NaN 且 不为+/-Infinity
 * - 对于数组: 检查每一个元素是否符合普通类型
 * @caution 空数组不为有效值
 */
export function isValidNumericValue(val: unknown): boolean {
  if (Array.isArray(val) && val.length === 0) {
    return false;
  }

  if (Array.isArray(val)) {
    return val.every(isValidNumericValue);
  }

  return typeof val === 'number' && !Number.isNaN(val) && Number.isFinite(val);
}
